import { registerPlugin } from '@capacitor/core';

import type { OrlikfyLocationServicesPlugin } from './definitions';

const OrlikfyLocationServices = registerPlugin<OrlikfyLocationServicesPlugin>('OrlikfyLocationServices', {
  web: () => import('./web').then((m) => new m.OrlikfyLocationServicesWeb())
});

export * from './definitions';
export { OrlikfyLocationServices };
